// AI-CONTEXT: See docs/features/arbeidsvaardigheden.md
import { LIKERT_NIVEAUS } from '../../../helpers/arbeidsvaardighedenHelpers/arbeidsvaardighedenStandaard'

// De kolommen lopen van de gunstige kant (5, links) naar de ongunstige (1,
// rechts), zodat de linkerpool van het formulier ook links op het scherm staat.
// Opgeslagen wordt de Likert-score, niet de kolomindex; zie de standaardmodule.
const KOLOMMEN = [...LIKERT_NIVEAUS].sort((a, b) => b - a)

/**
 * Eén effect als tegenpolenmatrix: links de positieve pool, rechts de negatieve,
 * daartussen vijf kolommen.
 *
 * De definitie van het effect zit in het `title`-attribuut en niet in de pagina.
 * Wie hem nodig heeft hovert; wie hem niet nodig heeft leest hem elke keer.
 *
 * Alle rijen zien er hetzelfde uit, ook de vijf die niet meetellen in de score.
 * De begeleider vult ze allemaal in en hoeft niet te weten welke doorwerken in
 * een cijfer (besluit 2026-08-28); het weglaten van de score gebeurt in
 * berekenEffectscores, niet op het scherm.
 *
 * @param {object} props
 * @param {object} props.effect - Effect uit de standaard
 * @param {Object<number, number>} props.antwoorden - Antwoorden van dit effect
 * @param {number|null} props.score - Berekende effectscore, of null als onaf
 * @param {number} props.beantwoord
 * @param {number} props.totaal
 * @param {boolean} props.readOnly
 * @param {(nummer: number, waarde: number|null) => void} props.onAntwoord
 */
const EffectMatrix = ({ effect, antwoorden = {}, score, beantwoord, totaal, readOnly, onAntwoord }) => (
    <section className="av-effect">
        <header className="av-effect-header">
            <h3 title={effect.definitie}>{effect.naam}</h3>
            <span className="av-effect-score">
                <span className={score === null ? 'av-score leeg' : 'av-score'}>
                    {score === null ? '—' : score.toFixed(1)}
                </span>
                <span className="av-effect-voortgang">{beantwoord}/{totaal}</span>
            </span>
        </header>

        <div className="av-matrix" role="group" aria-label={effect.naam}>
            {effect.stellingen.map((stelling) => {
                const gekozen = antwoorden[stelling.nummer]
                const naam = `${effect.id}-${stelling.nummer}`
                return (
                    <div key={stelling.nummer} className="av-rij">
                        <div className="av-pool links">{stelling.links}</div>
                        <div className="av-keuzes">
                            {KOLOMMEN.map((waarde) => (
                                <label key={waarde} className={gekozen === waarde ? 'av-keuze gekozen' : 'av-keuze'}>
                                    <input
                                        type="radio"
                                        name={naam}
                                        value={waarde}
                                        checked={gekozen === waarde}
                                        disabled={readOnly}
                                        onChange={() => onAntwoord(stelling.nummer, waarde)}
                                    />
                                    <span className="av-bol" aria-hidden="true" />
                                    <span className="av-schermlezer">
                                        {stelling.links} — {waarde} van 5
                                    </span>
                                </label>
                            ))}
                        </div>
                        {/* De cel blijft staan als het formulier geen tegenpool heeft
                            (EFF-09 #3 en #4), anders verspringt het raster. */}
                        <div className="av-pool rechts">{stelling.rechts || ''}</div>
                    </div>
                )
            })}
        </div>
    </section>
)

export default EffectMatrix
